/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
      this.totalItems = parseInt(this.dataset.totalItems) || 0;
      this.perPage = parseInt(this.dataset.perPage) || 0;
      this.progressText = this.querySelector('.load-more-progress__current');
      this.progressFill = this.querySelector('.load-more-progress__fill');
      this.progressContainer = this.querySelector('.load-more-progress');
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      if (search) {
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        if (base.i >= base.dataset.totalPages) {
          this.classList.add("hidden");
        }
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    updateProgress() {
      if (!this.progressText || !this.progressFill || !this.totalItems) return;
      var currentCount = this.grid ? this.grid.querySelectorAll('.column').length : 0;
      if (currentCount > this.totalItems) {
        currentCount = this.totalItems;
      }
      this.progressText.textContent = currentCount;
      var percentage = Math.min((currentCount / this.totalItems) * 100, 100);
      this.progressFill.style.width = percentage + '%';
      if (currentCount >= this.totalItems) {
        if (this.button) {
          this.button.classList.add('hidden');
        }
        if (this.progressContainer) {
          this.progressText.textContent = this.totalItems;
          this.progressFill.style.width = '100%';
        }
      }
    }
    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.getAttribute('loading')) {
        return;
      }
      base.i++;
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        });
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        base.updateProgress();
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
        products[i].querySelectorAll('.lazyload').forEach((image) => {
          lazySizes.loader.unveil(image);
        });
      }
      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute('loading');
            base.updateProgress();
          }
        });
      } else {
        base.removeAttribute('loading');
        base.updateProgress();
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}
